import React, { Component } from 'react';
import { Marker }           from "react-google-maps";
import icon                 from './../../assets/location.png';

class UserMarker extends Component
{
    componentWillUpdate = (nextProps) =>
    {
            if (nextProps.map.mapObject !== false && this.props.geo.coords !== nextProps.geo.coords)
            {
                let latLng = new window.google.maps.LatLng(nextProps.geo.coords.latitude, nextProps.geo.coords.longitude);
                nextProps.map.mapObject.panTo(latLng);
            }
    };

    getPin = () =>
    {
        if (null === this.props.pin)
        {
            return icon;
        }

        return this.props.pin;
    };


    render = () =>
    {
        if (null !== this.props.geo.coords)
        {
            return (
                <Marker
                    title="You are here"
                    position={ { lat: this.props.geo.coords.latitude, lng: this.props.geo.coords.longitude } }
                    key="user"
                    icon={ this.getPin() }
                />
            );
        }
        else
        {
            return null;
        }
    };

}

export default UserMarker;



// WEBPACK FOOTER //
// ./src/components/Map/UserMarker.js